import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { DashboardPageComponent } from './dashboard/containers/dashboard-page.component';
import { DashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';

@NgModule({
  imports: [
    CommonModule,
    AccountRoutingModule,
    LayoutModule,
    SharedModule
  ],
  declarations: [DashboardPageComponent, DashboardComponent]
})
export class AccountModule { }



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/account/account.module.ts